module.exports = function reducer_TeaserHd(state = {}) {
    return state;
};
